import { fmtAgo } from '@quadro/domain';
import { Avatar } from '../../components/Avatar';
import { Sheet, SheetFooter } from '../../components/Sheet';
import * as api from '../../data/api';
import { useAction, useNotices } from '../../data/queries';
import { closeSheet, openSheet } from '../../state/sheets';
import { useWorkspace } from '../../state/workspace';

const KIND: Record<api.Notice['kind'], string> = { assigned: 'Atribuída a você', mentioned: 'Menção', comment: 'Comentário' };

/** Avisos da pessoa: atribuições, menções e comentários nas tarefas dela. */
export function NotificationsSheet() {
  const ws = useWorkspace();
  const list = useNotices();
  const read = useAction(api.markNoticesRead, [['notifications']]);
  const items = list.data ?? [];
  const unread = items.filter(n => !n.readAt).length;
  return (
    <Sheet onClose={closeSheet} label="Avisos">
      <div className="sh-body">
        <h2>Avisos</h2>
        {!items.length && <p className="muted">{list.isPending ? 'Carregando…' : 'Nenhum aviso. Quando alguém atribuir uma tarefa a você ou mencionar você num comentário, aparece aqui.'}</p>}
        <ul className="nt">
          {items.map(n => (
            <li key={n.id} className={n.readAt ? '' : 'new'}>
              <button type="button" onClick={() => { if (!n.readAt) void read([n.id]); if (n.taskId) openSheet({ kind: 'task', id: n.taskId }); }}>
                <Avatar id={n.actorId} />
                <span className="nt-main">
                  <span className="nt-kind">{KIND[n.kind]} · {fmtAgo(n.createdAt)}</span>
                  <span className="nt-text">{n.text}</span>
                </span>
              </button>
            </li>
          ))}
        </ul>
      </div>
      <SheetFooter>
        {/* Na demonstração no navegador não há servidor para postar no Teams. */}
        {ws.isAdmin && !import.meta.env.VITE_DEMO && <button className="btn" onClick={() => openSheet({ kind: 'teams' })}>Avisos no Teams</button>}
        <span className="grow" />
        {unread > 0 && <button className="btn" onClick={() => read()}>Marcar todos como lidos</button>}
        <button className="btn primary" onClick={closeSheet}>Fechar</button>
      </SheetFooter>
    </Sheet>
  );
}
